import React from 'react'
// Components
import { CategoryButton } from '~2023/components/CategoryList'
import { Modal } from '~2023/components/CategoryList'

const ContainerCategory = () => {
  return (
    <>
      <CategoryButton />
      <Modal />
    </>
  )
}

export default ContainerCategory
